/**
 * Access a nested property via a dot-separated string path.
 * Replaces the deprecated `dottie.get()` package.
 *
 * Note: Unlike dottie.get(), escaped dots (e.g. 'foo.dot\\.dot') are NOT
 * supported. Property keys containing literal dots will not resolve correctly.
 */
export default function getByPath<T = unknown>(
  obj: Record<string, unknown> | undefined,
  path: string,
  defaultValue?: T
): T | undefined {
  const result = path
    .split('.')
    .reduce<unknown>(
      (acc, key) =>
        acc != null && typeof acc === 'object' ? (acc as Record<string, unknown>)[key] : undefined,
      obj
    );
  return (result === undefined ? defaultValue : result) as T | undefined;
}
